<template>
    <div 
        class="pivot-header-cell" 
        :class="headerClass"
        :style="headerStyle"
    >
        <div class="header-content">
            <i 
                v-if="expandable" 
                class="material-icons expand-icon"
                @click="$emit('toggle-expand')"
            >
                {{ expanded ? 'expand_more' : 'chevron_right' }}
            </i>
            <span class="header-label">{{ label }}</span>
            <i 
                v-if="sortable" 
                class="material-icons sort-icon"
                @click="$emit('sort')"
            >
                {{ sortIcon }}
            </i>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "PivotHeaderCell",
    props: {
        label: {
            type: String,
            required: true
        },
        expandable: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        },
        sortable: {
            type: Boolean,
            default: false
        },
        sortDirection: {
            type: String,
            default: null, // 'asc', 'desc', null
            validator: (value) => [null, 'asc', 'desc'].includes(value)
        },
        level: {
            type: Number,
            default: 0
        },
        isRowHeader: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        headerClass() {
            return {
                'is-row-header': this.isRowHeader,
                'is-column-header': !this.isRowHeader,
                'has-children': this.expandable,
                'is-expanded': this.expanded
            };
        },
        headerStyle() {
            if (this.isRowHeader) {
                return {
                    paddingLeft: (this.level * 20 + 12) + 'px'
                };
            }
            return {};
        },
        sortIcon() {
            if (!this.sortDirection) return 'unfold_more';
            return this.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
        }
    }
});
</script>

<style scoped lang="scss">
.pivot-header-cell {
    padding: 8px 12px;
    border: 1px solid #e8e8e8;
    background-color: #fafafa;
    font-weight: 600;
    font-size: 13px;
    position: sticky;
    z-index: 2;

    &.is-row-header {
        text-align: left;
        left: 0;
    }

    &.is-column-header {
        text-align: center;
        top: 0;
    }

    .header-content {
        display: flex;
        align-items: center;
        gap: 4px;

        .expand-icon {
            font-size: 18px;
            cursor: pointer;
            color: #666;
            transition: transform 0.2s;

            &:hover {
                color: #1890ff;
            }
        }

        .header-label {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .sort-icon {
            font-size: 16px;
            cursor: pointer;
            color: #999;
            transition: color 0.2s;

            &:hover {
                color: #1890ff;
            }
        }
    }

    &:hover {
        background-color: #f0f0f0;
    }
}
</style>
